import React from 'react';

import {MapContainer, TileLayer} from 'react-leaflet';

interface CustomMapProps {
  children?: React.ReactNode;
}
const CustomMap = ({children}: CustomMapProps) => {
  return (
    <div dir="ltr" className="w-full h-full">
      <MapContainer
        className="w-full h-screen rounded-md z-0"
        attributionControl={false}
        zoomControl={true}
        doubleClickZoom={false}
        scrollWheelZoom={true}
        easeLinearity={0.35}
        zoom={5}
        center={[32.0, 53.0]}
      >
        <TileLayer url="https://tile.openstreetmap.de/{z}/{x}/{y}.png" />
        {children}
      </MapContainer>
    </div>
  );
};

export default CustomMap;
